module.exports = __webpack_public_path__ + "static/media/Sanomat Grab Web-Regular TH.7a6f4c09.woff";